import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable} from "rxjs";

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent {

  @Input() aside$: Observable<boolean>;

  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();

  hideAside() {
    const aside = false
    this.dataEmitter.emit(aside)
  }

}
